import React from "react";
import { Image, Layer } from "react-konva";
import useImage from "use-image";

const BaseImage:React.FC<{
    imageUrl: string | null,
    width: number,
    height: number
 }> =  ({ imageUrl, width, height }) => {
    const [image] = useImage(imageUrl ?? "", "anonymous");
    const layerRef = React.useRef<any>(null);

    return (
        <Layer>
            <Image ref={layerRef} scaleX={width/(image?.width ?? 1)} scaleY={height/(image?.height ?? 1)} image={image}  />
        </Layer>
    );
};
export default BaseImage;